import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  useDispatch, connect, useSelector 
} from "react-redux";
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  UncontrolledAlert,  
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
// import { addOrder } from "store/Orders/actions";
import { addOrder } from "store/orders/actions";
import Select from "react-select";

import { AsyncPaginate } from "react-select-async-paginate";

import loadOptions from "./loadOptions";
import { getPricing } from "./../../../apis/orders";

function OrdersAddModal(props) {
  const { buttonText, t } = props;
  const [addModal, setAddOrderModal] = useState(false);
  const [symbolValue, setSymbolValue] = useState(null);
  const [type, setType] = useState(null);
  const [side, setSide] = useState(null);
  const [priceFlag, setPriceFlag] = useState(true);
  const [sympolAle, setsympolAle] = useState(false);
  const [typeAle, settypeAle] = useState(false);
  const [sideAle, setsideAle] = useState(false);
  const [pricing, setPricing] = useState("");
  const [showPricing, setShowPricing] = useState(false);
  const { clientDetails } = useSelector(state=>state.clientReducer);
  const dispatch = useDispatch();
  const toggleAddModal = () => {
    setAddOrderModal(!addModal);
  };
  const handleAddOrder = (e, values) => {
    values.symbol = symbolValue?.value;
    values.type = type;
    values.side = side;
    values.customerId = clientDetails?._id;
    Object.keys(values).forEach(key => {
      if (values[key] === "" || values[key] === null) {
        delete values[key];
      }
    });
    showAlert(symbolValue, type, side);
    if (symbolValue && type && side) {
      dispatch(addOrder(values));
      setSymbolValue(null);
      setShowPricing(false);
    }
  };
  const getPricingHandel = (pair) => {
    getPricing({
      pairName: pair
    })
      .then(response => {
        setShowPricing(true);
        setPricing("Current Price " + pair + ": " + (response.docs[0]?.marketPrice.$numberDecimal 
          ? response.docs[0]?.marketPrice.$numberDecimal : response.docs[0]?.marketPrice || "Not known"));
      }
      )
      .catch(() => {
      });
  };
  useEffect(() => {
    if (props.clearingCounter > 0 && addModal) {
      setTimeout(() => {
        setAddOrderModal(false);
      }, 1000);
    }
  }, [props.addSuccess]);

  const defaultAdditional = {
    page: 1,
  };
  const loadPageOptions = async (q, prevOptions, { page }) => {
    const { options, hasMore } = await loadOptions(q, page);

    return {
      options,
      hasMore,

      additional: {
        page: page + 1,
      },
    };
  };

  const sympolhandler = (val) => {
    getPricingHandel(val?.value);
    setSymbolValue(val);
  };
  const typehandler = (val) => {
    if (val?.value == "market") {
      setPriceFlag(false);
    } else {
      setPriceFlag(true);
    } 
    setType(val?.value);
  };
  const sidehandler = (val) => {
    setSide(val?.value);
  };
  const showAlert = (symopl, type, side) => {
    if (!symopl) {
      setsympolAle(true);
    }
    if (!type) {
      settypeAle(true);
    }
    if (!side) {
      setsideAle(true);
    }
    setTimeout(() => {
      setsideAle(false);
      settypeAle(false);
      setsympolAle(false);
    }, 3000);
  };

  return (
    <React.Fragment>
      <button to="#" className="btn btn-primary" onClick={toggleAddModal} disabled={props.isLead}>
        <i className={`bx ${!buttonText ? "bx-plus" : ""} me-1`}></i> {t(`${buttonText ? buttonText : "Add New"}`)}
      </button>
      <Modal isOpen={addModal} toggle={toggleAddModal} centered={true}>
        <ModalHeader toggle={toggleAddModal} tag="h4">
          {t("Add New Order")}
        </ModalHeader>
        <ModalBody>
          <AvForm
            className="p-4"
            onValidSubmit={(e, v) => {
              handleAddOrder(e, v);
            }}
          >
            {(showPricing) ?
              <label className="form-label font-size-18 ">{pricing.toString()}</label>
              : ""}
            <div className="mb-3">
              <label>{t("Symbol")}</label>
              <AsyncPaginate
                additional={defaultAdditional}
                value={symbolValue}
                loadOptions={loadPageOptions}
                onChange={sympolhandler}
                placeholder={t("Select Symbol")}
                errorMessage={t("please select Order symbol")}
                validate={{ required: { value: true } }}
              />
              {sympolAle && (
                <label className="form-label font-size-13 text-danger">{t("please select Order symbol")}</label>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="choices-single-default" className="form-label font-size-13 text-muted">{t("Type")}</label>
              <Select
                // value={selectedGroup}
                onChange={(val) => {
                  typehandler(val);
                }}
                options={[
                  {
                    label: t("Limit"),
                    value: "limit"
                  },
                  {
                    label: t("Market"),
                    value: "market"
                  }
                ]}
                classNamePrefix="select2-selection"
                placeholder={t("Select Type")}
              />
              {typeAle && (
                <label className="form-label font-size-13 text-danger">please select {t("Order Type")}</label>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="choices-single-default" className="form-label font-size-13 text-muted">{t("Side")}</label>
              <Select
                // value={selectedGroup}
                onChange={(val) => {
                  sidehandler(val);
                }}
                options={[
                  {
                    label: t("Buy"),
                    value: "buy"
                  },
                  {
                    label: t("Sell"),
                    value: "sell"
                  }
                ]} classNamePrefix="select2-selection"
                placeholder={t("Select Side")}
              />
              {sideAle && (
                <label className="form-label font-size-13 text-danger">{t("please select Order Side")}</label>
              )}
            </div>
            <div className="mb-3">
              <AvField
                name="amount"
                label={t("Amount")}
                placeholder={t("Enter Amount")}
                type="text"
                errorMessage={t("Enter Amount")}
                validate={{ required: { value: true } }}
                onKeyPress={(e)=>{
                  if (e.key == ".")
                    return true;
                  if (!/[0-9]/.test(e.key))
                    e.preventDefault();
                }}
              />
            </div>
            <div className="mb-3">
              <AvField
                name="tp"
                label={t("Take Profit")}
                placeholder={t("Enter Take Profit")}
                type="text"
                errorMessage={t("Enter Take Profit")}
                onKeyPress={(e)=>{
                  if (e.key == ".")
                    return true;
                  if (!/[0-9]/.test(e.key))
                    e.preventDefault();
                }}
              />
            </div>
            <div className="mb-3">
              <AvField
                name="sl"
                label={t("Stop Loss")}
                placeholder={t("Enter Stop Loss")}
                type="text"
                errorMessage={t("Enter Stop Loss")}
                onKeyPress={(e)=>{
                  if (e.key == ".")
                    return true;
                  if (!/[0-9]/.test(e.key))
                    e.preventDefault();
                }}
              />
            </div>
            {priceFlag ?
              <div className="mb-3">
                <AvField
                  name="price"
                  label={t("Price")}
                  placeholder={t("Enter Price")}
                  type="text"
                  errorMessage={t("Enter Price")}
                  validate={{ 
                    required: { 
                      value: true 
                    } 
                  }}
                  onKeyPress={(e)=>{
                    if (e.key == ".")
                      return true;
                    if (!/[0-9]/.test(e.key))
                      e.preventDefault();
                  }}
                />
              </div>
              : ""}
            <div className="text-center p-3">
              <Button type="submit" color="primary" className="">
                {t("Add New Order")}
              </Button>
            </div>
          </AvForm>
          {props.addError && (
            <UncontrolledAlert color="danger">
              <i className="mdi mdi-block-helper me-2"></i>
              {props.addErrorDetails}
            </UncontrolledAlert>
          )}
          {props.addSuccess && (
            <UncontrolledAlert color="success">
              <i className="mdi mdi-check-all me-2"></i>
              {t("Order Added successfully !!!")}
            </UncontrolledAlert>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  addLoading: state.ordersReducer.addLoading,
  addErrorDetails: state.ordersReducer.addErrorDetails,
  addSuccess: state.ordersReducer.addSuccess,
  addError: state.ordersReducer.addError,
  // managersData: state.ordersReducer.managersData,
  clearingCounter: state.ordersReducer.clearingCounter,
});
export default connect(mapStateToProps, null)(OrdersAddModal);
